export default __webpack_public_path__ + "static/media/banner-image-1-1.ef234a48.png";